import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { AuthService } from '@auth0/auth0-angular'

@Component({
  selector: 'app-sign-in',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SignInComponent {
  private readonly auth0Service = inject(AuthService, { optional: true })

  constructor() {
    afterNextRender(() => this.auth0Service?.loginWithRedirect().subscribe())
  }
}
